import * as React from "react";
import generateId from "logic/generateId";
export function isExternalLinkAction(action) {
  return "linkTarget" in action;
}
export function createHandlerFor(executeThunkAction, action, setActionComponents) {
  if ("handler" in action) {
    return action.handler;
  }
  if ("thunk" in action) {
    if (!executeThunkAction) {
      throw new Error(`Invalid binding for action: ${action.title} - thunk actions require 'executeThunkAction'.`);
    }
    return async (args) => executeThunkAction(action.thunk, args);
  }
  if (action.component) {
    const ActionComponent = action.component;
    return ({ field, value, type, contexts, ...restArgs }) => {
      const id = generateId();
      const onClose = () => setActionComponents(({ [id]: _, ...rest }) => rest);
      const componentProps = {
        onClose,
        field,
        value,
        type,
        contexts,
        ...restArgs
      };
      const renderedComponent = /* @__PURE__ */ React.createElement(ActionComponent, { key: action.title, ...componentProps });
      setActionComponents(
        (actionComponents) => ({
          [id]: renderedComponent,
          ...actionComponents
        })
      );
      return Promise.resolve();
    };
  }
  throw new Error(`Invalid binding for action: ${String(action)} - has neither 'handler' nor 'component'.`);
}
